import axios from 'axios';
import { NOTES_LIST } from '../../constants';

export const fetchNotesList = (pId, onError) => (dispatch) => {
  const token = localStorage.jwtToken;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  dispatch(loadNotesList());

  axios
    .get(`/client/listNotes?propertyId=${pId}`, config)
    .then((res) => dispatch(setNotesList(res)))
    .catch((err) => {
      dispatch(errorNotesList(err.response));
      onError(err.response);
    });
};

export const loadNotesList = () => ({
  type: NOTES_LIST.LOAD,
});

export const setNotesList = (userList) => ({
  type: NOTES_LIST.SUCCESS,
  payload: userList.data.data,
});

export const errorNotesList = (error) => ({
  type: NOTES_LIST.FAIL,
  payload: error,
});
